import { faro } from '@grafana/faro-web-sdk';

type PlayerIdentity = { gameId: number; playerId: number };

type TaggableSpan = { setAttribute(key: string, value: number): unknown };

export function identifyPlayer({ gameId, playerId }: PlayerIdentity): void {
  const user = { id: String(playerId), attributes: { gameID: String(gameId) } };
  if (faro.metas.value.user?.id === user.id) return;

  faro.api.setUser(user);
}

export function tagSpanWithPlayer(span: TaggableSpan): void {
  const user = faro.metas.value.user;
  if (!user?.id) return;

  span.setAttribute('player_id', Number(user.id));
  if (user.attributes?.gameID) span.setAttribute('game_id', Number(user.attributes.gameID));
}
